module.exports = __webpack_public_path__ + "images/emoji/copyright.845e9eff43e60436034a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/copyright.png
// module id = 8aYX
// module chunks = 13